import React from "react";
import cn from "classnames";
import { MineProperties } from "../../../types/mineTypes";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { POPUP_CONTAINER_ID } from "../index";
import styles from "./mapPopup.module.css";

interface MapPopupProps {
  closeButtonId: string;
  featureId: number;
  feature: { properties: MineProperties };
}

export const MapPopup = ({ feature, closeButtonId, featureId }: MapPopupProps) => {
  return (
    <div className={styles.container} data-feature-id={featureId} id={POPUP_CONTAINER_ID}>
      <div className={styles.innerContainer}>
        <div className={cn(styles.item, styles.header)}>
          <span className={styles.boldText}>{feature.properties?.mine_name_english || "N/A"}</span>
          <CloseIcon id={closeButtonId} className={styles.popupCloseIcon} />
        </div>
        <div className={styles.item}>
          <span className={styles.boldText}>{feature.properties.mine_name || "N/A"}</span>
        </div>
        <div className={styles.item}>
          <span>{feature.properties.Mine_Type} Mine</span>
        </div>
        <div className={styles.item}>
          <span>Owned by: {feature.properties.majority_owner || "N/A"}</span>
        </div>
        <div className={styles.item}>
          <span>Parent company of major shareholder: {feature.properties.FinalUBO_majority_owner_English || "N/A"}</span>
        </div>
      </div>
    </div>
  );
};
